// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-fixed-size[data-v-e2868404] {\n    width: 152px;\n    text-align: center;\n    /*margin: 0 10px;*/\n}\n\n", ""]);
// Exports
module.exports = exports;
